import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'page-header, [page-header], [pageHeader], mir-page-header, [mir-page-header], [mirPageHeader]',
    standalone: false
})
export class PageHeaderDirective {

  @HostBinding('class') hostCssClasses = 'mir-page-header page-header';

}
